import { Breadcrumb } from "@progress/kendo-react-layout";
import { useNavigate } from "react-router";

import { HOME_BREADCRUMB } from "./constants";

import type { BreadcrumbLinkMouseEvent, DataModel } from "@progress/kendo-react-layout";

import "./Breadcrumbs.scss";

interface BreadcrumbProps {
  data: DataModel[];
}

// TODO: Potentially a 'withBreadcrumbs' HOC
// TODO: Could be explicitly related to router
export const Breadcrumbs = ({ data }: BreadcrumbProps) => {
  const navigate = useNavigate();

  const handleItemSelect = (event: BreadcrumbLinkMouseEvent) => {
    const itemIndex: number = data.findIndex((value) => value.id === event.id);
    const breadcrumbPath = data.slice(0, itemIndex + 1);
    const url = breadcrumbPath
      .map((datum) => (datum.id === HOME_BREADCRUMB.id ? "" : datum.id))
      .join("/");

    navigate(url);
  };

  return (
    <Breadcrumb
      className="tc-breadcrumbs"
      data={data}
      onItemSelect={handleItemSelect}
      size="small"
    />
  );
};
